import { useTranslation } from "react-i18next";
import { PieChart, pieArcLabelClasses, pieArcClasses } from '@mui/x-charts/PieChart';

export default function AdDountsUi({ value }) {

    const { t } = useTranslation();
    const { i18n } = useTranslation();
    // The currentLang variable is kept if you need it for specific logic, 
    // though the API data provides the names directly now.
    const currentLang = i18n.language; 

    return (
        <>
            {/* Chart 1: Ads per Category */}
            <div className='chart-wrap w-full bg-thirdly flex flex-col justify-center gap-3 p-7 rounded-lg'>
                <label className='text-white mb-6 font-semibold text-lg text-right'>{t("charts.ads_per_category")}</label>
                <PieChart
                    series={[
                        {
                            arcLabel: (item) => `${item.value}`,
                            arcLabelMinAngle: 35,
                            arcLabelRadius: '60%',
                            // Dynamic Data Mapping
                            data: value?.ads_by_categories?.map((item, index) => ({
                                id: index,
                                value: item?.value,
                                // We wrap item.name in t() so you can translate "Electronics" to "الإلكترونيات" 
                                // in your translation files if needed. If not found, it shows the English name.
                                label: t(item?.name) 
                            })) || [] 
                        },
                    ]}
                    sx={{
                        [`& .${pieArcLabelClasses.root}`]: {
                            fontWeight: 'bold',
                            fill: '#1F1B2E !important',
                            fontSize: '17px !important',
                        },
                        [`& .${pieArcClasses.root}`]: {
                            stroke: 'none', // Remove the border from the arcs
                        },
                    }}
                    width={240}
                    height={240}
                />
            </div>

            {/* Chart 2: Geographic Distribution */}
            <div className='chart-wrap w-full bg-thirdly flex flex-col justify-center gap-3 p-7 rounded-lg'>
                <label className='text-white mb-6 font-semiblod text-lg text-right'>{t("charts.geographic_distribution_of_ads")}</label>
                <PieChart
                    series={[
                        {
                            arcLabel: (item) => `${item.value}`,
                            arcLabelMinAngle: 35,
                            arcLabelRadius: '60%',
                            // Dynamic Data Mapping
                            data: value?.ad_by_cities?.map((item, index) => ({
                                id: index,
                                value: item.value,
                                label: t(item.name) // Maps "Damascus", "Aleppo" etc.
                            })) || []
                        },
                    ]}
                    sx={{
                        [`& .${pieArcLabelClasses.root}`]: {
                            fontWeight: 'bold',
                            fontSize: '17px !important',
                            fill: '#1F1B2E !important',
                        },
                        [`& .${pieArcClasses.root}`]: {
                            stroke: 'none', // Remove the border from the arcs
                        },
                    }}
                    width={240}
                    height={240}
                />
            </div>
        </>
    );
};